export const cookieAttributes = {
  secure: true,
  expires: 1
};

// common key for webAuth app as well
export const encryptionSecretKey = {
  secretKey: 'nutshell'
};
